export const captivePortalConfig = {
  profileName: null,
  authTypeList: [
    {
      label: 'Click Through',
      value: 'CLICK_THROUGH',
      isActive: true,
    },
  ],
  idleTimeoutOption: 'DEFAULT', // DEFAULT / CUSTOM
  idleTimeoutList: [
    {
      label: '30 Mins',
      value: 30,
      isActive: false,
    },
    {
      label: '60 Mins',
      value: 60,
      isActive: true,
    },
  ],
  idleTimeoutLabel: 5,
  authTimeoutOption: 'DISABLE', // DISABLE / ENABLE / CUSTOM
  authTimeoutList: [
    {
      label: '1 Hour',
      value: 60,
      isActive: true,
    },
    {
      label: '8 Hours',
      value: 480,
      isActive: false,
    },
    {
      label: '1 Day',
      value: 1440,
      isActive: false,
    },
  ],
  authTimeoutLabel: 5,
  authPerDayOption: 'CUSTOM', // CUSTOM / UNLIMIT
  authPerDayLabel: 1,
  reAuthIntervalOption: 'DISABLE', // DISABLE / ENABLE / CUSTOM
  reAuthIntervalList: [
    {
      label: '15 Mins',
      value: 15,
      isActive: true,
    },
    {
      label: '30 Mins',
      value: 30,
      isActive: false,
    },
  ],
  reAuthIntervalLabel: 10,
  landingPageOption: 'NO_SPECIFIC', // NO_SPECIFIC / CUSTOM
  landingPageUrlProtocol: 'http', // http / https
  landingPageUrlLabel: null,
  whitelistList: [
    {
      label: 'Select',
      value: '',
      isActive: true,
    },
  ],
};
